import { useOutletContext } from 'react-router-dom'

import UpiLayout from '../components/UpiLayout/UpiLayout'

function UPI() {
  const data = useOutletContext()
  const { sectiondata, page } = data
  return (
    <UpiLayout
      cards={sectiondata?.cards || []}
      page={page}
      buttonText={sectiondata?.buttonText}
      hideVideo={sectiondata?.hide_video}
    />
  )
}

export default UPI
